
import { mapGetters, mapActions } from 'vuex';
export default {
    components: {
    },
    data() {
        return {
            animated_images: {
                src     : '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp',
                sizes   : '(max-width: 480px) 213px, (max-width: 768px) 280px, (min-width: 769px) 420px',
                srcset  : [
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_213.webp 213w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_280.webp 280w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp 420w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_560.webp 560w',
                ],
                loading : 'eager',
                alt : 'Portal de distribución mayorista de fajas que ofrece las principales marcas colombianas para revendedores en México'
            },
            animated_alts: [
                'Portal de distribución mayorista de fajas que ofrece las principales marcas colombianas para revendedores en México',
                'La fuente confiable de los distribuidores de fajas para fajas y cinturillas colombianas de alta calidad',
                'Fajas y prendas de compresión al por mayor para moldeado corporal y recuperación postquirúrgica',
                'Ordena cinturillas al por mayor en línea desde un portal líder B2B de fajas',
                'Fajas moldeadoras mayoristas mejor valoradas para tiendas de moda y redes de distribuidores',
                'Soluciones mayoristas de fajas para minoristas y negocios de ecommerce en México',
                'Opciones de distribución de fajas del principal proveedor mayorista de México',
                'Prendas de compresión al por mayor para minoristas que buscan alta calidad y envíos rápidos',
                'Soluciones B2B de fajas con pedidos al por mayor y registro de distribuidores simplificado',
                'Portal de fajas al por mayor con ofertas exclusivas para compradores primerizos',
                'Proveedores de fajas que ofrecen la última tecnología en moldeado corporal para clientes mayoristas',
                'Compra fajas moldeadoras y prendas de compresión al por mayor con pago seguro en portal B2B',
                'Fajas de moda al por mayor para boutiques y distribuidores de fajas en ecommerce',
                'Haz pedidos al por mayor de cinturillas a través de nuestro confiable portal de fajas',
                'La mejor plataforma B2B de fajas al por mayor para marcas colombianas y entregas rápidas en México',
                'Portal mayorista líder en fajas, cinturillas y prendas de compresión de alta calidad',
            ]
        }
    },
    async mounted() {
        
        let change_image = 2;
        setTimeout(() => {
            
            setInterval(() => {
                this.animated_images.src        = `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_420.webp`;
                this.animated_images.srcset     = [
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_213.webp 213w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_280.webp 280w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_420.webp 420w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_560.webp 560w`
                ];
                this.animated_images.alt        = this.animated_alts[ change_image - 1 ];
                change_image++;
                if( change_image == 18 ) {
                    
                    change_image = 1;
                }
            }, 200);
        }, 6000);
    },
    computed: {
        ...mapGetters({
        }),
        getAnimatedImage(){
            
            return this.animated_images;
        }
    },
    methods: {
        ...mapActions({
        })
    }
}
